












import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetail } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetail
  },
  mixins: [RenderMenuMixin]
})

/**
 * 员工数据 -（数据明细-创作管理方）
 */
export default class StatisticStaffManagerDetail extends Vue {

  private comicId: number | null = null; // 漫画id
  private userId: number = 0; // 用户id

  private created() {
    const { id, userid } = this.$route.params;
    if (id) {
      this.comicId = parseInt(id, 10);
    }
    this.userId = parseInt(userid, 10);
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="staff"></acgn-statics-menu>
    );
  }
}
